var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNonCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5856_4653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7212 5.96136C16.3499 5.58959 15.747 5.58982 15.3752 5.96136L9.31744 12.0194L6.62503 9.32697C6.25325 8.95519 5.65061 8.95519 5.27883 9.32697C4.90706 9.69874 4.90706 10.3014 5.27883 10.6732L8.6442 14.0385C8.82998 14.2243 9.07357 14.3174 9.31719 14.3174C9.5608 14.3174 9.80463 14.2245 9.9904 14.0385L16.7212 7.30753C17.0929 6.93602 17.0929 6.33311 16.7212 5.96136Z",
    fill: "#CCD0D8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5856_4653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonCheck);
export default __webpack_public_path__ + "static/media/nonCheck.fa79effb024d1c3a85f91644050a37ef.svg";
export { ForwardRef as ReactComponent };